import React, { useState, useEffect, useCallback } from 'react'
import { Grid } from '@material-ui/core'
import { Datagrid, Button } from '@refera/ui-web'
import HeaderTitle from '_/components/header-title'
import { navigate } from '@reach/router'
import { useDispatch, useSelector } from 'react-redux'
import { getAiAssistants } from '_modules/ai-integration/actions'
import { ROUTES } from '_utils/constants'
import {
  aiAssistantsListSelector,
  aiAssistantsFilterSelector,
  aiAssistantsCountSelector,
} from '_modules/ai-integration/selectors'

import useStyles, { datagridStyle } from './styles'

import { IaAssistantsColumns } from './utils/constants'
import { useToast } from '_/hooks/use-toast'

export function IaAssistants() {
  const styles = useStyles()
  const dispatch = useDispatch()
  const { showToast } = useToast()
  const aiAssistants = useSelector(aiAssistantsListSelector)
  const count = useSelector(aiAssistantsCountSelector)
  const filters = useSelector(aiAssistantsFilterSelector)
  const [page, setPage] = useState(filters?.page || 0)
  const [pageSize, setPageSize] = useState(filters?.pageSize || 10)
  const [orderBy, setOrderBy] = useState(filters?.orderBy || '')
  const [loadAssitants, setLoadAssistants] = useState(false)

  useEffect(() => {
    setLoadAssistants(true)
    dispatch(getAiAssistants({ ...filters, page: page + 1, pageSize, orderBy }))
      .catch(() =>
        showToast({ type: 'error', message: 'Ocorreu um erro ao buscar os assistentes de IA' })
      )
      .finally(() => setLoadAssistants(false))
  }, [page, pageSize, orderBy])

  const handleOrderBy = orderObj => {
    const order = orderObj[0]
    if (!order) {
      setOrderBy('createdAt')
      return
    }

    const { field, sort } = order
    setOrderBy(`${sort === 'desc' ? '-' : ''}${field}`)
  }

  const handleEditAssistant = useCallback(event => {
    navigate(`${ROUTES.IA_ASSISTANTS}/${event.row.id}`)
  }, [])

  const handleCreate = useCallback(() => {
    navigate(`${ROUTES.IA_ASSISTANTS}/novo`)
  }, [])

  return (
    <>
      <HeaderTitle title="Assistentes de IA" backButtonAction={() => navigate(-1)}>
        <Button onClick={() => handleCreate()}>Novo</Button>
      </HeaderTitle>

      <Grid className={styles.tableContainer}>
        <Grid className={styles.mainTable}>
          <Datagrid
            rows={aiAssistants}
            rowCount={count}
            loading={loadAssitants}
            getRowId={row => row.slug}
            columns={IaAssistantsColumns(styles)}
            paginationMode="server"
            onPageChange={setPage}
            page={page}
            onPageSizeChange={setPageSize}
            pageSize={pageSize}
            onSortModelChange={handleOrderBy}
            sx={datagridStyle}
            onRowClick={handleEditAssistant}
          />
        </Grid>
      </Grid>
    </>
  )
}
